"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentBank = void 0;
const AbstractBatcherBank_1 = require("./base/AbstractBatcherBank");
const DeploymentModel_1 = require("../models/DeploymentModel");
class DeploymentBank extends AbstractBatcherBank_1.AbstractBatcherBank {
    constructor(options) {
        super(options);
        this.options = options;
    }
    generate(data) {
        return new DeploymentModel_1.DeploymentModel({
            banks: this.options.banks(),
            clients: this.options.clients,
            model: data
        });
    }
    async fetchCollection(event) {
        const client = this.options.clients.provisionDeployServiceClient();
        for (let item of event.items) {
            let dep = null;
            try {
                dep = await client.getDeployment({
                    deployment_id: item
                });
            }
            catch (ex) { }
            if (!dep) {
                try {
                    dep = await client.getDeploymentByBackend({
                        backend_deployment_id: item
                    });
                }
                catch (ex) { }
            }
            if (!dep) {
                event.notFound(item);
                continue;
            }
            event.apply({
                [dep.id]: dep
            });
            // also apply it as the backend id
            if (dep.backend.deployment_id) {
                event.apply({
                    [dep.backend.deployment_id]: dep
                });
            }
        }
    }
    patch(event) {
        event.object.options.model = event.data;
    }
}
exports.DeploymentBank = DeploymentBank;
